<page-data-manager>
  <div class="row border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h2 class="inline">Máquinas</h2><br/>
          <button type="button"
                  class="btn btn-primary btn-action m-t-md pull-right"
                  ng-disabled="mq.createNew"
                  ng-click="mq.createNew = true"
                  ng-if="mq.permissions.canManage">
            Nova
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="col-xs-12">
          <!-- New maquina -->
          <edit-maquina ng-if="mq.createNew" groups="mq.groups"></edit-maquina>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <!-- Search box -->
    <cadastro-search-box submit="mq.searchMaquinas()" clear="mq.clearFilters()" show-clear="mq.isFiltering()">
      <div class="row">
        <div class="form-group col-xs-6">
          <label for="search-descricao" class="control-label">Descrição</label>
          <input type="text" class="form-control" name="searchDescricao" id="search-descricao" ng-model="mq.search.descricao">
        </div>
        <div class="form-group col-xs-6">
          <label for="search-grupo" class="control-label">Grupo</label>
          <ui-select name="searchGrupo" id="search-grupo" ng-model="mq.search.grupo">
            <ui-select-match>{{$select.selected.descricao | capitalize}}</ui-select-match>
            <ui-select-choices repeat="grupo in mq.groups | orderBy: 'descricao' | filter: $select.search">
              <span ng-bind-html="grupo.descricao | capitalize | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
    </cadastro-search-box>

    <!-- Loader -->
    <p class="text-cinza preloader text-center" ng-show="mq.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
    </p>

    <div class="ibox">
      <!-- List -->
      <p class="ibox-content padding" ng-if="!mq.loading && !mq.maquinas.length">
        Nenhuma máquina encontrada.
      </p>
      <div class="ibox-content text-right pagination-container no-top-border border-bottom" ng-show="mq.paginationVisible()">
        <pagination walk="mq.setPage(page)" pages="mq.pages"></pagination>
      </div>
      <div class="faq-item" ng-class="{'faq-item-last': $last}" ng-repeat="maquina in mq.maquinas track by $index" data-index="{{$index}}">
        <a class="faq-question" ng-click="mq.openEdit($index)">
          {{maquina.descricao}}
          <i class="fa fa-pencil" ng-if="mq.permissions.canManage"></i>
          <i class="glyphicon glyphicon-eye-open" ng-if="mq.permissions.canRead && !mq.permissions.canManage"></i>
        </a>
        <small>{{maquina.grupo.descricao | capitalize}}</small>
        <edit-maquina maquina="maquina"
                      groups="mq.groups"
                      ng-if="mq.permissions.canRead && maquina.edit"></edit-maquina>
      </div>
      <div class="ibox-content pagination-container text-right" ng-show="mq.paginationVisible()">
        <pagination walk="mq.setPage(page)" pages="mq.pages"></pagination>
      </div>
    </div>
  </div>
</page-data-manager>
